
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { ValidationProvider } from 'vee-validate';
import FormGroup from '@/components/form/FormGroupNew.vue';
import FormSelect from '@/components/form/FormSelect.vue';
import FormMultiselect from '@/components/form/FormSelectNew.vue';
import _ from 'lodash';

@Component({
  components: {
    ValidationProvider,
    FormGroup,
    FormSelect,
    FormMultiselect,
  },
})
export default class RequiredServices extends Vue {
  @Prop({ required: true }) readonly formData!: Record<string, any>;
  localFormData: Record<string, any> = {};
  isFrequencySelect: boolean = false;

  supportTypeOptions = [
    { label: 'Landscaping / Gardening Services', value: 'Landscaping / Gardening Services' },
    { label: 'Housekeeping / Cleaning Services', value: 'Housekeeping / Cleaning Services' },
    { label: 'Domestic Support Worker (DSW)', value: 'Domestic Support Worker (DSW)' },
    { label: 'Home Support Worker (HSW)', value: 'Home Support Worker (HSW)' },
    { label: 'Companion', value: 'Companion' },
    { label: 'Personal Support Worker (PSW)', value: 'Personal Support Worker (PSW)' },
    { label: 'Registered Nurse (RN)', value: 'Registered Nurse (RN)' },
    { label: 'Licensed Practical Nurse (LPN)', value: 'Licensed Practical Nurse (LPN)' },
    { label: 'Registered Practical Nurse (RPN)', value: 'Registered Practical Nurse (RPN)' },
    { label: 'Home Health Aide (HHA)', value: 'Home Health Aide (HHA)' },
    { label: 'Health Care Assistant (HCA)', value: 'Health Care Assistant (HCA)' },
    { label: 'Care Aide', value: 'Care Aide' },
    { label: 'Med Tech (Medical Technician)', value: 'Med Tech (Medical Technician)' },
    { label: 'Physiotherapist', value: 'Physiotherapist' },
    { label: 'Blood Work / Lab Services', value: 'Blood Work / Lab Services' },
    { label: 'Occupational Therapist (OT)', value: 'Occupational Therapist (OT)' },
    { label: 'Speech-Language Pathologist (SLP)', value: 'Speech-Language Pathologist (SLP)' },
    { label: 'Dietitian / Nutritionist', value: 'Dietitian / Nutritionist' },
    { label: 'Massage Therapist (RMT)', value: 'Massage Therapist (RMT)' },
    { label: 'Respite Worker', value: 'Respite Worker' },
    { label: 'Hospice Worker', value: 'Hospice Worker' },
    { label: 'Palliative Care Specialist', value: 'Palliative Care Specialist' },
    { label: 'Social Worker', value: 'Social Worker' },
    { label: 'Case Manager / Care Coordinator', value: 'Case Manager / Care Coordinator' },
    { label: 'Transportation Driver (medical appointments, errands)', value: 'Transportation Driver (medical appointments, errands)' },
    { label: 'Meal Delivery / Prep Services', value: 'Meal Delivery / Prep Services' },
    { label: 'Grocery Delivery Support', value: 'Grocery Delivery Support' },
    { label: 'Handyman / Home Safety Modifications', value: 'Handyman / Home Safety Modifications' },
    { label: 'Technology Support Specialist (devices, telehealth setup)', value: 'Technology Support Specialist (devices, telehealth setup)' },
    { label: 'Pet Care Support', value: 'Pet Care Support' },
    { label: 'Domestic Support Worker', value: 'Domestic Support Worker' },
  ];

  frequencyOptions = [
    { label: 'Daily', value: 'Daily' },
    { label: 'Weekly', value: 'Weekly' },
    { label: 'As Needed', value: 'As Needed' },
  ];

updateFrequence(val){
  if(val.includes('Housekeeping / Cleaning Services')){
    this.isFrequencySelect = true;
  }
  else{
    this.isFrequencySelect = false;
  }
}
  // get isFrequencySelect() {

  //   if (this.formData?.support_type?.length > 0) {
  //     return this.formData?.support_type?.some(each => each.value === 'Housekeeper')
  //   }
  //   return false
  // }

  @Watch('formData', { immediate: true, deep: true })
  onFormDataChange(newVal: Record<string, any>) {
    if(this.localFormData?.support_type?.some(each => each.value === 'Housekeeping / Cleaning Services')){
      this.localFormData['frequency'] = this.localFormData.frequency.value;
       this.isFrequencySelect = true;
    }
    this.localFormData = _.cloneDeep(newVal);
  }

  updateField(field: string, value: any) {
    this.localFormData[field] = value;
    this.$emit('update:formData', this.localFormData);
  }
}
